import { fetcher } from "helpers/fetcher";

import {
  TGetStaffMaternityChldrenLeaveReq,
  TGetStaffMaternityChldrenLeaveRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffMaternityChldrenLeave = async (
  payload: TGetStaffMaternityChldrenLeaveReq
) => {
  return await fetcher<
    TGetStaffMaternityChldrenLeaveRes,
    TGetStaffMaternityChldrenLeaveReq["data"]
  >(ENDPOINT.USER.GET_STAFF_MATERNITY_CHILDREN_LEAVE, {
    params: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.USER.GET_STAFF_MATERNITY_CHILDREN_LEAVE.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const queryGetStaffMaternityChldrenLeave = async (
  payload: TGetStaffMaternityChldrenLeaveReq
) => {
  return (await getStaffMaternityChldrenLeave(payload)).data;
};

queryGetStaffMaternityChldrenLeave._key = (
  payload: TGetStaffMaternityChldrenLeaveReq
) => [ENDPOINT.USER.GET_STAFF_MATERNITY_CHILDREN_LEAVE.url, payload];
